import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { useMemo } from 'react'

export const useIsIntegrationsV3 = (): boolean => {
  const isIntegrationsV3Enabled = useFlipperFlag('integrations_v3')
  const workspace = useCurrentWorkspace()
  const isVirtualMarketer = !!workspace?.is_virtual_marketer

  const isEnabled = useMemo<boolean>(() => {
    return isIntegrationsV3Enabled && isVirtualMarketer
  }, [isIntegrationsV3Enabled, isVirtualMarketer])

  return isEnabled
}
